export default __webpack_public_path__ + "certificate.130e061f.svg";